import { withKeycloak } from "@react-keycloak/web";
import { labels } from "../../../../localization/labels";
import { selectFilter } from "../../../../services/FilteringUtils";
import KnowledgeService from "../../../../services/KnowledgeService";
import TableUtils from "../../../core/Table/TableUtils";
import LookupComponentContainer from "../../page/LookupComponent";

class KnowledgeItemsLookupContainer extends LookupComponentContainer {
  constructor(props) {
    super(props);

    this.placeholder = labels.chooseEntityPlaceholder;

    this.knowledgeService = new KnowledgeService(this.keycloak);
  }

  initialSortInfo() {
    return {
      orderBy: "id",
      direction: "desc"
    };
  }

  lookupTitle() {
    return labels.relatedEntities;
  }

  loadData = pageInfo => {
    this.adjustPageInfo(pageInfo);

    this.prepareCall(
      this.knowledgeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  adjustPageInfo = pageInfo => {
    if (this.props.omittedKnowledgeItem) {
      pageInfo.filters = {
        ...pageInfo.filters,
        id: selectFilter(this.props.omittedKnowledgeItem.id, "NOTIN")
      };
    }
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id-filtered",
      headerFormatter: this.formatHeader
      // filter: TableUtils.textFilter(labels.id, Comparator.EQ)
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      formatter: TableUtils.textFormatter,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.name)
    },
    {
      dataField: "description",
      text: labels.description,
      sort: true,
      formatter: TableUtils.textFormatter,
      headerClasses: "column-header-filtered",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.description)
    }
  ]);
}

export default withKeycloak(KnowledgeItemsLookupContainer);
